import { render, staticRenderFns } from "./Ingredient_question.vue?vue&type=template&id=119db6a8&scoped=true&"
import script from "./Ingredient_question.vue?vue&type=script&lang=js&"
export * from "./Ingredient_question.vue?vue&type=script&lang=js&"
import style0 from "./Ingredient_question.vue?vue&type=style&index=0&id=119db6a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119db6a8",
  null
  
)

export default component.exports